import styled from 'styled-components';

export const FormWrap = styled.div`
  /* max-width: 522px; */

  &.ltr {
    .honey {
      left: -5000px;
    }
  }
  &.rtl {
    .honey {
      left: 5000px;
    }
  }
`;

export const Form = styled.form``;

export const ButtonWrap = styled.div``;
